export const INITIAL_STATE = (set, get, store) => ({
    botName: null,
    media: [],
    preferredLanguage: {},
    isReadOnly: null,
    userText: [],
    chatHistory: [],
    errorText: null,
    currentPage: null,
    actionItemSource: null,
    selectedAction: null,
    userProblemStatement: null,
    selectedObjective: null,
    profileId: null,
    systemError: null,
    actionList: null,
    lastFetchedActionListObjective: null,
    isChatVisible: null,
    session: null,
    introMessage: null,
    botMessageName: null,
    firstName: null,
    objective: null,
    objectiveSource: null,
    hasClickedObjAddMore: null,
    hasClickedActionAddMore: null,
    chunks: null,
    projectTitle: null,
    selectedWeek: null,
    company: null,
    introEndContext: null,
    selectedObjectiveSource: null,
    selectedActionSource: null,
    durationChatHistory: [],
    objectiveChatHistory: [],
    actionListChatHistory: [],
    initialSwitchChatHistory: [],
    selectedFlowType: null,
    commonFlowChatHistory: [],
    commonFlowIntroMessage: null,
    durationIntroMessage: null,
    prevObjective: null,
    prevObjectiveSource: null,
    isPrevObjectiveShown: false,
    objectListRetries: 0,
    isOwnObjective: false,
    projectId: null,

    setBotMessageName: botMessageName => set({ botMessageName }),
    getBotMessageName: () => get().botMessageName,
    setMedia: media => set({ media }),
    getMedia: () => get().media,
    setPreferredLanguage: preferredLanguage => set({ preferredLanguage }),
    getPreferredLanguage: () => get().preferredLanguage,
    setIsReadOnly: isReadOnly => set({ isReadOnly }),
    getIsReadOnly: () => get().isReadOnly,
    setUserText: userText => set({ userText }),
    getUserText: () => get().userText,
    setChatHistory: chatHistory => set({ chatHistory }),
    getChatHistory: () => get().chatHistory,
    setErrorText: errorText => set({ errorText }),
    getErrorText: () => get().errorText,
    setCurrentPage: currentPage => set({ currentPage }),
    getCurrentPage: () => get().currentPage,
    setActionItemSource: actionItemSource => set({ actionItemSource }),
    getActionItemSource: () => get().actionItemSource,
    setSelectedAction: selectedAction => set({ selectedAction }),
    getSelectedAction: () => get().selectedAction,
    setUserProblemStatement: userProblemStatement => set({ userProblemStatement }),
    getUserProblemStatement: () => get().userProblemStatement,
    setSelectedObjective: selectedObjective => set({ selectedObjective }),
    getSelectedObjective: () => get().selectedObjective,
    setProfileId: profileId => set({ profileId }),
    getProfileId: () => get().profileId,
    setSystemError: systemError => set({ systemError }),
    getSystemError: () => get().systemError,
    setActionList: actionList => set({ actionList }),
    getActionList: () => get().actionList,
    setLastFetchedActionListObjective: lastFetchedActionListObjective => set({ lastFetchedActionListObjective }),
    getLastFetchedActionListObjective: () => get().lastFetchedActionListObjective,
    setIsChatVisible: isChatVisible => set({ isChatVisible }),
    getIsChatVisible: () => get().isChatVisible,
    setSession: session => set({ session }),
    getSession: () => get().session,
    setIntroMessage: introMessage => set({ introMessage }),
    getIntroMessage: () => get().introMessage,
    setBotName: botName => set({ botName }),
    getBotName: () => get().botName,
    setFirstName: firstName => set({ firstName }),
    getFirstName: () => get().firstName,
    setObjective: objective => set({ objective }),
    getObjective: () => get().objective,
    setObjectiveSource: objectiveSource => set({ objectiveSource }),
    getObjectiveSource: () => get().objectiveSource,
    setHasClickedObjAddMore: hasClickedObjAddMore => set({ hasClickedObjAddMore }),
    getHasClickedObjAddMore: () => get().hasClickedObjAddMore,
    setHasClickedActionAddMore: hasClickedActionAddMore => set({ hasClickedActionAddMore }),
    getHasClickedActionAddMore: () => get().hasClickedActionAddMore,
    setCompany: company => set({ company }),
    getCompany: () => get().company,
    setIntroEndContext: introEndContext => set({ introEndContext }),
    getIntroEndContext: () => get().introEndContext,
    getChunks: () => get().chunks,
    setChunks: () => chunks => set({ chunks }),
    getProjectTitle: () => get().projectTitle,
    setProjectTitle: projectTitle => set({ projectTitle }),
    getSelectedWeek: () => get().selectedWeek,
    setSelectedWeek: selectedWeek => set({ selectedWeek }),

    setSelectedObjectiveSource: selectedObjectiveSource => set({ selectedObjectiveSource }),
    getSelectedObjectiveSource: () => get().selectedObjectiveSource,

    setSelectedActionSource: selectedActionSource => set({ selectedActionSource }),
    getSelectedActionSource: () => get().selectedActionSource,

    setDurationChatHistory: durationChatHistory => set({ durationChatHistory }),
    getDurationChatHistory: () => get().durationChatHistory,

    setObjectiveChatHistory: objectiveChatHistory => set({ objectiveChatHistory }),
    getObjectiveChatHistory: () => get().objectiveChatHistory,

    setPrevObjective: prevObjective => set({ prevObjective }),
    getPrevObjective: () => get().prevObjective,

    setPrevObjectiveSource: prevObjectiveSource => set({ prevObjectiveSource }),
    getPrevObjectiveSource: () => get().prevObjectiveSource,

    setIsOwnObjective: isOwnObjective => set({ isOwnObjective }),
    getIsOwnObjective: () => get().isOwnObjective,

    setIsPrevObjectiveShown: isPrevObjectiveShown => set({ isPrevObjectiveShown }),
    getIsPrevObjectiveShown: () => get().isPrevObjectiveShown,

    setObjectListRetries: objectListRetries => set({ objectListRetries }),
    getObjectListRetries: () => get().objectListRetries,

    setActionListChatHistory: actionListChatHistory => set({ actionListChatHistory }),
    getActionListChatHistory: () => get().actionListChatHistory,

    setInitialSwitchChatHistory: initialSwitchChatHistory => set({ initialSwitchChatHistory }),
    getInitialSwitchChatHistory: () => get().initialSwitchChatHistory,

    setSelectedFlowType: selectedFlowType => set({ selectedFlowType }),
    getSelectedFlowType: () => get().selectedFlowType,

    setCommonFlowChatHistory: commonFlowChatHistory => set({ commonFlowChatHistory }),
    getCommonFlowChatHistory: () => get().commonFlowChatHistory,

    setCommonFlowIntroMessage: commonFlowIntroMessage => set({ commonFlowIntroMessage }),
    getCommonFlowIntroMessage: () => get().commonFlowIntroMessage,

    setDurationIntroMessage: durationIntroMessage => set({ durationIntroMessage }),
    getDurationIntroMessage: () => get().durationIntroMessage,

    setProjectId: projectId => set({ projectId }),
    getProjectId: () => get().projectId,

  
    reset: () => {
      set(store.getInitialState())
    },
  })
  